import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './SocialLoginButtonView.scss';
import withTranslations from '../../components/utils/Translations/withTranslations';
import translatePropTypes from '../../translatePropTypes';
import Spinner from '../../components/utils/Spinner';
import propTypes from '../../propTypes';

@withTranslations
export default class SocialLoginButtonView extends React.PureComponent {
  static networkName(type) {
    switch (type) {
      case 'GOOGLE':
        return 'Google';
      case 'MICROSOFT':
        return 'Microsoft';
      default:
        return '';
    }
  }

  static networkIcon(type) {
    switch (type) {
      case 'GOOGLE':
        return '/images/google.png';
      case 'MICROSOFT':
        return '/images/microsoft.png';
      default:
        return '';
    }
  }

  static propTypes = {
    type: propTypes.socialAccountType.isRequired,
    onClick: PropTypes.func,
    buttonRef: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    titleTemplate: PropTypes.string,
    loading: PropTypes.bool,
    ...translatePropTypes,
  };

  static defaultProps = {
    titleTemplate: null,
    className: null,
    disabled: false,
    loading: false,
    onClick: null,
    buttonRef: null,
  };

  render() {
    const {
      t,
      type,
      titleTemplate,
      disabled,
      loading,
      className,
      onClick,
      buttonRef,
    } = this.props;

    const title = titleTemplate
      ? titleTemplate
      : // ? t(titleTemplate, { name: SocialLoginButtonView.networkName(type) })
        SocialLoginButtonView.networkName(type);

    return (
      <button
        ref={buttonRef}
        className={classnames(
          className,
          styles.m3,
          { [styles.loading]: loading },
          'btn btn-default btn-raised btn-labeled',
        )}
        disabled={disabled}
        type="button"
        onClick={onClick}
      >
        <b className={styles.imageContainer}>
          <img src={SocialLoginButtonView.networkIcon(type)} width="18" />
        </b>

        <span className={styles.title}>
          {title}
          {loading && (
            <span className={styles.spinner}>
              <Spinner inline />
            </span>
          )}
        </span>
      </button>
    );
  }
}
